export default {
	data(){
		return {
			emptyRecipients:  {
				id_subscribers: [],
				id_brands: [],
				id_operators: [],
				id_services: [],
				id_channel_packages: [],
				device_type_codes: [],
				subscriber_type: null,
				id_subscriber_tags: [],
			},
			entity: {
				name: '',
				subject: {'cs': ''},
				label: {'cs': ''},
				body: {'cs': ''},
				show_at: null,
				show_to: null,
				qr_code_text: null,
				qr_code_image: null,
				qr_code_url: null,
				image_url: null,
				trigger_channel_ids: [],
				confirm_per_device: false,
				action_type: 'none',
				action_id: null,
				device_group_settings: {
					firstscreen: true,
					secondscreen: true,
				},
				combine_recipient_conditions: false,
				recipients: {
					id_subscribers: [],
					id_brands: [],
					id_operators: [],
					id_services: [],
					id_channel_packages: [],
					device_type_codes: [],
					subscriber_type: null,
					id_subscriber_tags: [],
				},
				send_to_all: false
			},
			updateFields: [
				'name',
				'subject',
				'label',
				'body',
				'show_at',
				'show_to',
				'qr_code_text',
				'qr_code_url',
				'qr_code_image',
				'image_url',
				'action_type',
				'action_id',
				'trigger_channel_ids',
				'device_group_settings',
				'confirm_per_device',
				'combine_recipient_conditions',
				'recipients',
				'send_to_device_group_type',
				'send_to_all'
			],
		}
	},
	methods: {
		isRecipientsValid(){
			return this.entity.send_to_all || !this._.isEqual(this.entity.recipients, this.emptyRecipients);
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/advertisingBanner/mixins/entity.js